import React from 'react'
import { Region, transformRegionToMap, useConfig } from 'msp-integrations'
import { NavFooter } from '@organisms/Footer/Footer.partials'
import FooterLogo from '@atoms/FooterLogo/FooterLogo'
import SocialMediaElements from '@molecules/SocialMediaElements/SocialMediaElements'
import ServiceCustomLink from '@molecules/ServiceCustomLink/ServiceCustomLink'
import Icons from '@atoms/Icons/Icons'
import MainWrapper from '@atoms/MainWrapper/MainWrapper'

import {
  CheckoutUSP,
  FooterPaymentIcons,
  FooterShippingMethods
} from './FooterCheckout.partials'
import * as T from '@organisms/Footer/Footer.types'
import { getStyles } from '@organisms/Footer/Footer.styles'

const FooterCheckout = ({
  regions,
  i18nProp,
  fourthColumnSlot,
  disableNavigation = false,
  socialMediaItems,
  playStoreLink,
  appStoreLink
}: T.FooterProps) => {
  const areas = transformRegionToMap(regions)
  const config = useConfig()
  const S = getStyles(config)

  return (
    <div className={S.FooterMainWrapper}>
      <MainWrapper>
        <div className={S.FooterSubWrapper}>
          <FooterLogo
            iconName={config.theme.mspComponents?.footer?.icon}
            iconWidth={config.theme.mspComponents?.footer?.iconWidth}
            notClickable={disableNavigation}
          />
        </div>
        <div
          className={`footer-links ${config.theme.mspComponents?.footerCheckout} text-20 mb-28 mt-2 justify-around px-10 md:mt-16 md:grid md:grid-cols-2 md:px-0 lg:grid-cols-4`}
        >
          <div className='order-3 mb-8 flex flex-col md:mb-0 lg:order-none'>
            <div className='order-2 flex justify-center md:order-1 md:justify-start'>
              <CheckoutUSP />
            </div>
            <div className='order-1 mb-8 flex justify-center md:order-2 md:mb-0 md:justify-start'>
              <SocialMediaElements socialMediaItems={socialMediaItems} />
            </div>
          </div>
          <div className='order-1 mb-8 lg:order-none lg:mb-0'>
            {!disableNavigation && config.tenantId === 'puro' && (
              <Region
                region={areas.get('column2')}
                className={S.NavLinksRegion}
              />
            )}
            <div className='flex justify-center md:justify-start'>
              <ServiceCustomLink
                textClassname={`${config.theme.font.regular} text-16 leading-20 underline lowercase`}
              >
                {config.info?.supportEmail}
              </ServiceCustomLink>
            </div>
            <div className='flex justify-center md:justify-start'>
              <ServiceCustomLink
                textClassname={`${config.theme.font.regular} text-16 leading-20 underline lowercase`}
                url={`mailto:${config.info?.tel}`}
              >
                {config.info?.tel}
              </ServiceCustomLink>
            </div>
          </div>
          <div className='order-2 mb-8 list-none lg:order-none lg:mb-0'>
            {!disableNavigation && config.tenantId === 'jasmin' && (
              <Region
                region={areas.get('column3')}
                className={S.NavLinksRegion}
              />
            )}
            <FooterPaymentIcons />
          </div>
          <div className='order-4 lg:order-none'>
            <Region
              className='flex justify-center md:justify-start'
              region={areas.get('column4')}
            />
            <FooterShippingMethods />
            <div className='flex w-full flex-row justify-center pt-3 md:justify-start'>
              <div className={S.AppleStoreWrapper}>
                <ServiceCustomLink
                  url={appStoreLink || '#'}
                  icon={
                    <Icons
                      iconName='AppleAppStore'
                      asFile
                      width='94px'
                      height='32px'
                    />
                  }
                  iconWrapperClassname='fill-white'
                />
              </div>
              <div className={S.GoogleStoreWrapper}>
                <ServiceCustomLink
                  url={playStoreLink || '#'}
                  icon={
                    <Icons
                      iconName='GoogleAppStore'
                      asFile
                      width='108px'
                      height='32px'
                    />
                  }
                  iconWrapperClassname='fill-white'
                />
              </div>
            </div>
            {fourthColumnSlot}
          </div>
        </div>
        {!disableNavigation && (
          <NavFooter i18nProp={i18nProp} style={S}>
            <Region
              region={areas.get('navfooter')}
              className={S.NavFooterRegion}
            />
          </NavFooter>
        )}
      </MainWrapper>
    </div>
  )
}

export default FooterCheckout
